import { styled } from '@aibi-ui/core';
import GifUserBg from '../../../assets/images/user-bg.gif';
import Icons from '../../../components/Icons';
import UserIcon from '../../../components/UserIcon';
import { UserWithPermissionsAndRoles } from 'src/types/bootstrapTypes';
import { ensureAppRoot } from 'src/utils/pathUtils';
import { useEffect } from 'react';
import rison from 'rison';
import { formatFullname } from 'src/utils/common';

const UserInfoStyled = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(170deg, #cde0ff 0%, #fff 5%);
  border: 1px solid rgba(188, 209, 247, 0.5);
  border-radius: 6px;

  .user {
    padding: 32px 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .user-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 12px;

      .avatar {
        width: 50px;
        height: 50px;
      }

      .info {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .username {
          color: #2e405d;
          font-size: 16px;
          font-weight: 600;
        }

        .dept {
          color: #3b4b67;
          font-size: 14px;
        }
      }
    }

    .user-right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: row;
      gap: 4px;
      color: #3b4b67;
      font-size: 15px;
      cursor: pointer;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  .ai-tip {
    position: relative;
    aspect-ratio: 452 / 171;
    overflow: hidden;

    .gif {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 0;
    }

    .title {
      z-index: 1;
      position: relative;
      margin-top: 60px;
      padding: 0 52px;
      font-size: 15px;
      color: #2e405d;

      span {
        color: #5687ff;
      }
    }

    .content {
      z-index: 1;
      position: relative;
      margin-top: 10px;
      padding: 0 64px 0 52px;
      line-height: 22px;
      font-size: 14px;
      color: #2e405d;
    }
  }

  .login-info {
    margin: 0 20px;
    padding-top: 24px;
    border-top: 1px solid #f5f6f8;

    .title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 4px;
      font-size: 16px;
      color: #2e405d;
    }

    .content {
      .login-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 12px;
        gap: 8px;
        font-size: 15px;
        color: #3b4b67;

        .login-label {
          min-width: 60px;
        }

        .login-value {
        }
      }
    }
  }
`;

const UserInfo = ({ user }: { user: UserWithPermissionsAndRoles }) => {
  const toUserInfo = () => {
    window.location.href = ensureAppRoot('/user/info');
  };
  const name = formatFullname(user.firstName, user.lastName);

  return (
    <UserInfoStyled>
      <div className="user">
        <div className="user-left">
          <UserIcon username={name} className="avatar" />
          <div className="info">
            <div className="username">{user.username}</div>
            <div className="dept">部门</div>
          </div>
        </div>
        <div className="user-right" onClick={toUserInfo}>
          <span>个人中心</span>
          <Icons.DetailArrow viewBox="0 0 16 17" />
        </div>
      </div>
      <div className="ai-tip">
        <img className="gif" src={GifUserBg} alt="gif" />
        <div className="title">
          Hi~ <span>{name}</span>
        </div>
        <div className="content">
          我是你的校园ai助手,我能根据你的指令,帮你查询数据,分析数据,并通过可视化图表展示结果
        </div>
      </div>
      <div className="login-info">
        <div className="title">
          <Icons.LoginIp viewBox="0 0 24 30" />
          <span>上次登录信息</span>
        </div>
        <div className="content">
          <div className="login-item">
            <div className="login-label">时间: </div>
            <div className="login-value">2025-02-01 11:11</div>
          </div>
          <div className="login-item">
            <div className="login-label">IP地址: </div>
            <div className="login-value">199.199.199.199</div>
          </div>
          <div className="login-item">
            <div className="login-label">地点: </div>
            <div className="login-value">重庆市</div>
          </div>
        </div>
      </div>
    </UserInfoStyled>
  );
};

export default UserInfo;
